import { removeCookie, ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, ORGANIZATION_ID_KEY } from '@eva-pacs/core';
export var removeAuthCookies = function () {
    removeCookie(ACCESS_TOKEN_KEY);
    removeCookie(REFRESH_TOKEN_KEY);
    removeCookie(ORGANIZATION_ID_KEY);
};
